(function(exports) {
  var utils = exports.slideshare_object.utils,
      POST = 'POST',
      GET = 'GET',
      PUT = 'PUT',
      DELETE = 'DELETE';

  /**
   * Object used for all api interactions
   */
  function Api() {}

  /**
   * Adds an annotation for a clip within a clipboard.
   *
   * @param {Number} clipboardId The clipboard id
   * @param {Number} clipId The clip id
   * @param {String} annotation The annotation text
   */
  Api.prototype.addAnnotation = function(clipboardId, clipId, annotation) {
    return this._ajax('/clipboards/' + clipboardId + '/clips/' + clipId + '/add_annotation', POST, {
      annotation: annotation
    });
  };

  /**
   * Adds a clip to a clipboard
   *
   * @param {Number} clipboardId The clipboard id
   * @param {Number} clip The clip to be added
   */
  Api.prototype.addClipToClipboard = function(clipboardId, clip) {
    return this._ajax('/clipboards/' + clipboardId + '/clips', POST, clip);
  };

  /**
   * Adds several clips to a clipboard
   *
   * @param {Number} clipboardId
   * @param {Array<Number>} clipIds
   */
  Api.prototype.addClips = function(clipboardId, clipIds) {
    return this._ajax('/clipboards/' + clipboardId + '/clips/bulk', POST, {
      ids: clipIds
    });
  };

  /**
   * Reclip several clips to a clipboard
   *
   * @param {Number} clipboardId
   * @param {Number} sourceClipboardId
   * @param {Array<Number>} clipIds
   */
  Api.prototype.reclipClips = function(clipboardId, sourceClipboardId, clipIds) {
     return this._ajax('/clipboards/' + clipboardId + '/clips/bulk_reclip', POST, {
      source_clipboard_id: sourceClipboardId,
      ids: clipIds
    });
  };

  /**
   * Gets the list of clipboards.
   */
  Api.prototype.clipboards = function() {
    return this._ajax('/clipboards', GET);
  };

  /**
   * Creates a clipboard
   *
   * @param {Object} clipboard The clipboard to be created
   */
  Api.prototype.createClipboard = function(clipboard) {
    return this._ajax('/clipboards', POST, clipboard);
  };

  /**
   * Deletes a clip and removes it from all clipboards where it appears.
   * @param {Number} clipId
   */
  Api.prototype.deleteClip = function(clipId) {
    return this._ajax('/clips/' + clipId, DELETE);
  };

  /**
   * Deletes a clip from a clipboard
   *
   * @param {Number} clipboardId
   * @param {Number} clipId
   */
  Api.prototype.deleteClipFromClipboard = function(clipboardId, clipId) {
    return this._ajax('/clipboards/' + clipboardId + '/clips/' + clipId, DELETE);
  };

  /**
   * Deletes multiple clips from a clipboard
   *
   * @param {Number} clipboardId
   * @param {Array<Number>} clipIds
   */
  Api.prototype.deleteClipsFromClipboard = function(clipboardId, clipIds) {
    return this._ajax('/clipboards/' + clipboardId + '/clips/bulk', DELETE, {
      ids: clipIds
    });
  };

  /**
   * Deletes a clipboard
   *
   * @param {Number} id The clipboard id
   */
  Api.prototype.deleteClipboard = function(clipboardId) {
    return this._ajax('/clipboards/' + clipboardId, DELETE);
  };

  /**
   * Edits a clipboard
   *
   * @param {Number} id The clipboard id
   * @param {Object} data The clipboard data
   */
  Api.prototype.editClipboard = function(clipboardId, data) {
    return this._ajax('/clipboards/' + clipboardId, PUT, data);
  };

  /**
   * Reorders clip positions in a clipboard
   *
   * @param {Number} clipboardId
   * @param {Array<Object>} clipsOrder
   */
  Api.prototype.reorderClips = function(clipboardId, clipsOrder) {
    return this._ajax('/clipboards/' + clipboardId + '/clips/reorder', POST, {
      clips_order: clipsOrder
    });
  };

  /**
   * Gets the top clipboards for slideshow slide
   * @param {Number} slideshowId The slideshow id
   * @param {Number} position The slide position
   */
  Api.prototype.topClipboards = function(slideshowId, position) {
    return this._ajax('/clipboards/top', GET, {
      slideshow_id: slideshowId,
      position: position
    });
  };

  /**
   * Makes an ajax request with the specified parameters
   * @private
   *
   * @param {String} url
   * @param {String} type method type
   * @param {Object} data
   */
  Api.prototype._ajax = function(url, type, data) {
    return $.ajax({
      url: url,
      type: type,
      dataType: 'json',
      contentType: 'application/json',
      data: (type === GET) ? data : JSON.stringify(data)
    });
  };

  utils.exports('clips.api', new Api());
})(window);
